export default {
  titulo: "Repairs",
  new: "New repair",
  busqueda: "Search by order number, equipment or client name",
  equiposEntregados: "Delivered equipment",
  compartir: "Share order details",
  linkDesc: "Order link for the client",
  copiarLink: "Copy",
  msgLinkCopiado: "The order detail link has been copied.",
  pregEliminar: "Are you sure you want to delete the repair order?",
  labelMotivoEliminar: "Indicate the reason",
  listadoAdjuntos: "Attachments list",
  msgStep1: "To continue with the repair you must select a Client",
  msgStep2: "To continue with the repair you must select Equipment",
  msgStep3: "To continue with the repair you must write some equipment problem",
  msgStep4: "To continue you must select a technician.",
  msgEquipoEnTaller: "You cannot add this equipment as it is already in workshop on repair order #",
  tituloVerOrden: "Repair Order #",
  informeMantencion: "Maintenance report",
  finalizar: "Finish",
  entregar: "Deliver",
  imprimirEntrega: "Re-print delivery",
  pregFinalizar: "Do you want to finalize the repair order?",
  pregEntregar: "Do you want to deliver the repair order?",
  imprimirOrdenFinalizada: "Print finalized order report",
  errorEntregada: "Action cannot be completed because the order was delivered",
  textSeleccionarCliente: "Select an option to enter client data.",
  registrarCliente: "Register a new client",
  buscarCliente: "Search a registered client",
  detallesCliente: "Client details",
  noDataCliente: "No client selected",
  textOrdenSinEquipo: "Activate this option if the order has no associated equipment",
  registrarEquipo: "Register a new equipment",
  buscarEquipo: "Search a registered equipment",
  detallesEquipo: "Equipment details",
  noDataEquipo: "No equipment selected",
  fechaPrometida: "Promised repair date",
  nroManual: "Manual order number",
  categoria: "Category",
  errorCategoria: "Please select a category",
  sucursal: "Branch",
  errorSucursal: "Please select a branch",
  depto: "Department/Area",
  errorDepto: "Please select a department/area",
  dineroACuenta: "Money delivered as down payment",
  errorMonto: "Please enter a valid amount",
  asignacion: "Technician assignment",
  msgAsignacion: "If you assign the repair to another person you will be notified to stay aware of the new task to perform",
  usuario: "User",
  grupo: "Group",
  seleccionar: "Select",
  seleccionado: "Selected",
  creando: "Creating repair",
  hayPlural: "There are",
  haySingular: "There is",
  textAgendadosPlural: "Repairs scheduled for",
  textAgendadosSingular: "Repair scheduled for",
  ingreso: "Entry",
  personaContacto: "Contact person",
  asociarEquipo: "Associate equipment to order",
  msgNoHayPermiso: "You do not have permission to modify this order",
  problema: "Reported problem",
  editarProblema: "Edit reported problem",
  editarFecha: "Edit promised date",
  tituloEstados: "Order statuses",
  msgSinFirmar: "The order has not yet been signed via the app",
  aclaracion: "Clarification",
  documento: "Document",
  textInforme: "Enter the order report",
  nuevaNota: "New note",
  eliminarNota: "Delete note",
  pregEliminarNota: "Are you sure you want to delete this note?",
  presupuesto: {
    manoObra: "Labor",
    rma: "RMA",
    repuestos: "Spare parts",
    entrega: "Down payment",
    impuestos: "Taxes",
    total: "Total budget",
    email: "Send by Email",
    wpp: "Send by Whatsapp",
  },
  rma: {
    enviar: "Send equipment to RMA",
    recibir: "Receive equipment",
    nroIntervencion: "Intervention number",
    detalle: "Detail",
    tituloDetalle: "Equipment details in RMA",
    tituloRecibir: "Receive equipment from RMA",
    msgEquipoEnRma: "The equipment is already in RMA",
    btnValidar: "Validate equipment",
    buscarSerie: "Search by equipment serial number",
    falla: "Fault",
    fallaLabel: "Fault reason for sending"
  },
  estados: {
    "Sin Revisar": "Not Reviewed",
    "En Reparación": "Under Repair",
    "Reparación Terminada": "Repair Completed"
  },
  verRegistros: "View order records",
  tituloRegistros: "Repair order records",

}
